<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusGuadalajara",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/instalaciones-guadalajara-1.webp',
                    '/pagesImages/instalaciones-Guadalajara-3.webp',
                    '/pagesImages/instalaciones-Guadalajara-4.webp',
                    '/pagesImages/instalaciones-guadalajara-5.webp',
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Guadalajara.webp",
                    // "/pagesImages/encabezado-landing-Guadalajara.webp",
                ],
                altArray: [
                    "Universidad Humanitas Campus Guadalajara",
                    "Universidad Humanitas Campus Guadalajara",
                ],
                tour: [
                    { src:"/pagesImages/tour-Guadalajara-1.webp", title:"Tour virtual en Campus Ejecutivo Guadalajara"},
                    { src:"/pagesImages/tour-Guadalajara-2.webp", title:"Tour virtual en Campus Ejecutivo Guadalajara"},
                    { src:"/pagesImages/tour-Guadalajara-3.webp", title:"Tour virtual en Campus Ejecutivo Guadalajara"},
                    { src:"/pagesImages/tour-Guadalajara-4.webp", title:"Tour virtual en Campus Ejecutivo Guadalajara"},
                ],
                campusName: "GUADALAJARA",
                campusType: "CAMPUS EJECUTIVO",
                localidad: "Jalisco",
                frase: "La búsqueda de la verdad es más preciosa que su posesión",
                autor: "Albert Einstein",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus ejecutivo'" :testo1="'Es un centro académico de alto nivel, creado especialmente para ofrecer formación académica integral. Se distingue por su formato ejecutivo, ubicado en un edificio corporativo, moderno y funcional, ideal para estudiantes que valoran el tiempo, la eficiencia y la calidad.'" :testo2="'Una de sus principales características es que conjuga la excelencia académica con el enfoque humano, por lo que se posiciona como una institución líder en la formación de profesionales.'" :img="'/pagesImages/una-mirada-Guadalajara.webp'" :alt="'Campus Ejecutivo Guadalajara'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Las instalaciones de este campus reflejan un estilo corporativo contemporáneo, con espacios cómodos, tecnológicos<br class="lg:block hidden"> y versátiles que promueven el aprendizaje dinámico y colaborativo.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras. Este espacio fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Oficinas ejecutivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Este campus simula escenarios reales del mundo corporativo con inmuebles de primer nivel e instalaciones modernas.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Instalaciones de Campus Ejecutivo Guadalajara"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        :alt="alts[currentImage2]"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas verdes y deportivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Modernas instalaciones deportivas, como canchas de futbol rápido y baloncesto, equipadas con gradas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:mb-4 lg:px-0 px-8 leading-none w-full">Oferta académica en Campus Guadalajara</h2>
    <Oferta :Licenciaturas="'/pagesImages/landing-virtual-estudiante.webp'" :Maestrias="'/pagesImages/landing-virtual-mujer.webp'" :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', 'Educación' ],
        Maestrías: ['Psicoterapia con un<br> enfoque Psicoanalítico', 'Derecho Fiscal'],
    }" class="flex items-center justify-center" />
    <section class="flex w-full items-center justify-center text-gray-700 mt-10">
        <div class="flex flex-col w-full max-w-[1200px] justify-center items-center">
            <div class="flex flex-col md:flex-row items-center justify-center mb-16 w-full max-w-4xl lg:max-w-[1200px]">
                    <div class="order-2 md:order-1 flex w-full md:w-1/2 justify-center md:justify-end lg:px-0 px-8">
                        <img src="/pagesImages/landing-virtual-doctorado.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Explora los diplomados">
                    </div>
                    <div class="order-1 md:order-2 flex flex-col lg:px-14 px-8 md:py-0 w-full md:w-1/2 items-center md:items-start">
                        <p class="text-center md:text-left line-height-36 text-4xl text-hgold mb-4 font-serif">Diplomados</p>
                        <ul class="text-left pl-6 space-y-1 list-disc">
                            <li><a href="https://humanitas.edu.mx/educacion-continua">Criminología</a></li>
                        </ul>
                        <br>
                    </div>
                </div>
        </div>
    </section>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/vasos-cafe-despierta.webp" alt="Vasos de café de Despierta" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo Escolarizado</span>
                                </h3>
                                <p class="">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Ejecutivo Guadalajara en nuestro tour virtual.</p>
            <Instalaciones :items="tour" class="mb-8" />
            <!-- <iframe width="1140" height="641" src="https://www.youtube.com/embed/qBOIBjsj3RE" title="Campus Presa Madín" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
        </div>
    </div>
	<Ubicacion :campus="'Campus Ejecutivo Guadalajara'" :mapa="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7465.74114318384!2d-103.392424!3d20.674844!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428ae0d31cd03d3%3A0x90798f7809446d8d!2sUniversidad%20Humanitas%20Campus%20Guadalajara!5e0!3m2!1ses-419!2smx!4v1745614244433!5m2!1ses-419!2smx'" :testo1="'Las vías de acceso para este campus es Av. Ignacio L. Vallarta y Av. Juan Paloma y Arias. Mientras que las siguientes líneas de transporte tienen rutas que pasan cerca de estas vías son: C109 - A, C110 - B, C110-venta, C140 (710), y línea 1.'" :ubicacion="'Av. Vallarta 3298, Edificio O, Piso 1, Col. Vallarta San Lucas, Torre de Oficinas, Espacio Minerva, Guadalajara C.P. 44690, Jalisco.'" :telefono="'33-3615-8806'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
